'use-client';
import * as React from 'react';
import WPhoto from '../../WPhotoBase';
import type { SkinWPhotoProps } from '../SkinWPhoto';
import type { BaseWPhotoSkinProps } from '../../../WPhoto.types';
import skinsStyles from './styles/ScotchTopPhoto.scss';
import BasicWPhotoSkin from './BasicWPhotoSkin';

const ScotchTopPhotoSkin: React.FC<
  Omit<BaseWPhotoSkinProps, 'skinsStyle'>
> = props => <BasicWPhotoSkin {...props} skinsStyle={skinsStyles} />;

const ScotchTopPhoto: React.FC<SkinWPhotoProps> = props => (
  <WPhoto {...props} skin={ScotchTopPhotoSkin} />
);

export default ScotchTopPhoto;
